import * as deviationActions from '../actions/deviations.actions';
import { DeviationApiModel } from 'app/models/deviation-api.model';
import { Action, on, createReducer } from '@ngrx/store';
import { MwPayloadModel } from 'app/models/payload.model';

export interface State {
  deviations: MwPayloadModel<DeviationApiModel[]>;
  isLoading: boolean;
  isReady: boolean;
}

export const initialState: State = {
  deviations: {
    results: [],
    count: 0,
  },
  isLoading: false,
  isReady: false,
};

export const featureReducer = createReducer(
  initialState,
  on(deviationActions.loadDeviations, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(deviationActions.loadDeviationsSuccess, (state: State, { response }) => ({
    ...state,
    isLoading: false,
    isReady: true,
    deviations: response,
  }))
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
